import type { Language } from "@/Common/Models/Domain/Language";
import type { Locale } from "../Model/Domain";

import useI18nStore from "../Store";

import { getLocale } from "@/Services/TherapyApi/Translations";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";
import LocaleTransformer from "@/Modules/Transformers/Locale";
import localeCacheService from "../Services/LocaleCacheService";

async function FetchLocaleActionHandler(locale: Language): Promise<Locale | undefined> {
  const I18nStore = useI18nStore();

  const localeResp = await getLocale(locale);

  if (isApiError(localeResp)) {
    return undefined;
  }

  const domainLocale = LocaleTransformer.toDomain(localeResp);

  I18nStore.locales.set(domainLocale.locale, domainLocale);
  localeCacheService.set(domainLocale);

  return domainLocale;
}

export default FetchLocaleActionHandler;
